<template>
  <home-floating-window
    :title="$t('FiberCircuit')"
    @close="close"
    @changePosition="$emit('changeClusterWindowsPosition', $event)"
    :pos-x="position.x"
    :pos-y="position.y"
    :height="139"
    :width="width"
    @changeSize="changeSize($event)"
    :is-resizing="true"
    :circuit="circuit"
  >
    <template v-slot:iconWindows>
      <v-icon class="pr-2">settings_input_composite</v-icon>
    </template>
    <template v-slot:objectDivWindows>
      <v-card :loading="loading">
      <div class="floating-tool-content">
        <div class="scroll-fire-fox">
          <div style="text-align: left; margin: 0">
            <label> {{ $tc("Circuit", 1) }}: </label>
            <treeselect
              v-model="circuit"
              :options="allCircuits"
              :normalizer="listElementNormalizer"
              :load-options="getFiberCircuit"
              disableFuzzyMatching
              :clearable="false"
              valueFormat="object"
              :disabled="loading"
            />
          </div>
          <div class="floating-objects-wrapper" v-if="circuit">
            <label class="font-weight-bold">
              {{ $t("LossValue") }}: {{ circuit.loss_value.toFixed(2) }}
            </label>
            <v-layout
              row
              align-center
              justify-start
              v-for="object in circuit.circuit"
              :key="object.uuid"
              style="margin-bottom: 5px; margin-top: 5px"
            >
              <div class="floating-object-selected" style="width: 100%; ">
                <v-flex style="width: 20%; text-align: -webkit-center;">
                  <div
                    class="port-object"
                    v-if="
                      object.subtype === 'fc_port' && object.type === 'node'
                    "
                  />

                  <div
                    class="cable-fiber-object"
                    v-if="
                      object.subtype === 'fc_fiber' ||
                        object.subtype === 'fc_cable'
                    "
                    :style="{
                      height: getHeightCable(object),
                      'margin-top': getMarginTopCable(object),
                      'margin-bottom': getMarginBottomCable(object)
                    }"
                  />

                  <component
                    v-else
                    style="z-index: 2"
                    class="floating-img"
                    :is="getImageName(object.subtype)"
                  />
                </v-flex>
                <v-flex style="width: 80%; text-align: initial; ">
                  <div class="fiber-circuit-item">
                    <span
                      style="text-align: left; line-height: 1; word-break:break-all;"
                      :class="{
                        'fiber-circuit-select': object.uuid === fiberUuid
                      }"
                    >
                      {{ getObjectLabel(object) }}
                    </span>
                    <span
                      v-if="object.subtype === 'fc_fiber'"
                      class="grey--text"
                      >({{ object.loss_value.toFixed(2) }})</span
                    >
                  </div>
                </v-flex>
              </div>
            </v-layout>
          </div>
        </div>
      </div>
    </v-card>
    </template>
  </home-floating-window>
</template>

<script>
import HomeFloatingWindow from "@/components/Home/Content/ObjectWindow/HomeFloatingWindow";
import SplitterSVG from "@/assets/tools_svgs/splitter.svg";
import ClosureSVG from "@/assets/tools_svgs/closureFill.svg";
import TechLocalSVG from "@/assets/tools_svgs/techLocalFill.svg";
import BuildingSVG from "@/assets/tools_svgs/uniFill.svg";

import { mapActions } from "vuex";
import { bus } from "@/main";

export default {
  name: "FiberCircuitWindow",

  components: { HomeFloatingWindow },

  props: {
    fiberUuid: String,
    position: Object
  },

  data() {
    return {
      allCircuits: null,
      circuit: null,
      loading: false,

      height: 300,
      width: 300
    };
  },
  watch: {
    fiberUuid() {
      this.getFiberCircuit();
    },

    circuit(newSelect) {
      this.removeHighlightFromFiberCircuitSelection();
      if (newSelect) {
        this.addHighlightToFiberCircuitSelection(newSelect);
      }
    }
  },

  methods: {
    ...mapActions(["fetchFiberCircuitByUuid"]),

    close() {
      this.removeHighlightFromFiberCircuitSelection();
      this.$emit("close");
    },

    changeSize(size) {
      this.width = size.width;
      this.height = size.height;
    },

    async getFiberCircuit() {
      if (this.fiberUuid && !this.loading) {
        this.loading = true;
        this.allCircuits = null;
        this.circuit = null;
        try {
          this.allCircuits = await this.fetchFiberCircuitByUuid(this.fiberUuid);

          if (this.allCircuits.length === 0) {
            this.$toasted.global.toast_warning(this.$i18n.t("NoCircuitsFound"));
            this.close();
          }
        } catch (e) {
          console.error(e);

          this.$toasted.global.toast_error(e.data);
          this.close();
        }
        this.loading = false;
      }
    },

    listElementNormalizer(node) {
      return {
        id: this.allCircuits.indexOf(node),
        label: this.getListElementLabel(node)
      };
    },

    getListElementLabel(listElement) {
      return (
        listElement.source + " " + this.$i18n.t("To") + " " + listElement.target
      );
    },

    getObjectLabel(object) {
      let label = object.label ? object.label : object.id;
      if (object.subtype === "fc_fiber") {
        return "F: " + label;
      } else if (object.subtype === "fc_port") {
        return "Sp: " + label;
      } else if (object.subtype === "fc_closure") {
        return "Cl: " + label;
      } else if (object.subtype === "fc_technical_local") {
        return "Pn: " + label;
      } else if (object.subtype === "fc_cable") {
        return "Sp: " + label + ": " + object.cable_length;
      } else if (object.subtype === "fc_building") {
        return "Bd: " + label;
      }
    },

    getImageName(type) {
      if (type === "fc_port") {
        return SplitterSVG;
      } else if (type === "fc_closure") {
        return ClosureSVG;
      } else if (type === "fc_technical_local") {
        return TechLocalSVG;
      } else if (type === "fc_building") {
        return BuildingSVG;
      }
    },

    getHeightCable(object) {
      let height = "30px";
      if (object.subtype === "fc_fiber") {
        if (
          object.source_connection === "passing" &&
          object.target_connection === "passing"
        ) {
          height = "48px";
        } else if (
          object.source_connection === "passing" ||
          object.target_connection === "passing"
        ) {
          height = "45px";
        }
      }
      return height;
    },

    getMarginTopCable(object) {
      return object.source_connection === "splice" &&
        object.target_connection === "passing"
        ? "10px"
        : 0;
    },

    getMarginBottomCable(object) {
      return object.source_connection === "passing" &&
        object.target_connection === "splice"
        ? "10px"
        : 0;
    },

    removeHighlightFromFiberCircuitSelection() {
      bus.$emit("remove-highlight-from-fiber-circuit-selected");
    },

    addHighlightToFiberCircuitSelection(newSelection) {
      for (const object of newSelection.circuit) {
        if (object.geom) {
          bus.$emit(
            "highlight-object-from-fiber-circuit-selected",
            JSON.stringify(object.geom.geojson_geom)
          );
        }
      }
    }
  }
};
</script>

<style scoped>
.fiber-circuit-select {
  text-decoration: underline;
}
.floating-object-selected:hover {
  background-color: transparent;
}
.cable-fiber-object {
  width: 5px;
  border-left: 3px solid var(--primary-highlight);
  z-index: 0;
  padding-right: 10px;
}

.port-object {
  width: 10px;
  border-left: 1px dashed var(--primary-highlight);
  z-index: 0;
  height: 12px;
  padding-right: 10px;
}

.floating-objects-wrapper {
  overflow-y: scroll;
  margin-top: 15px;
  max-height: 551px;
}

.floating-img {
  width: 22px;
  height: 30px;
  margin-right: 10px;
}
.fiber-circuit-item {
  display: flex;
  flex-flow: column wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/ObjectWindow/FiberCircuit/FiberCircuitWindow.vue